import { LabelWeight } from '../components/Weight/Label';

export const packagesColumns = [
  { label: '', width: '50px', mobile: true },
  {
    label: 'Type',
    value: 'type',
    mobile: true,
  },
  {
    label: <LabelWeight label="Weight" />,
    value: 'weight',
  },
  {
    label: '',
    value: '',
    mobile: true,
  },
];

export const settingChickenTabs = [
  {
    label: 'Fried Materials',
    value: 'materials',
  },
  {
    label: 'Grilled Materials',
    value: 'grilled-materials',
  },
  {
    label: 'Containers',
    value: 'containers',
  },
  {
    label: 'Merco Trays',
    value: 'mercoTrays',
  },
  {
    label: 'Packages',
    value: 'packages',
  },
];

export const settingPotatoTabs = [
  {
    label: 'Materials',
    value: 'materials',
  },
  {
    label: 'Packages',
    value: 'packages',
  },
];

export const presetSelectColors = [
  '#D0021B',
  '#F5A623',
  '#F8E71C',
  '#8B572A',
  '#7ED321',
  '#417505',
  '#BD10E0',
  '#FA33C5',
  '#9013FE',
  '#4A90E2',
  '#50E3C2',
  '#B8E986',
  '#000000',
  '#4A4A4A',
  '#9B9B9B',
  '#FFFFFF',
];

export const chickenTags = [
  {
    label: 'Cookable',
    value: 'COOKABLE',
  },
  {
    label: 'Production',
    value: 'PRODUCTION',
  },
  {
    label: 'Scheduled Production',
    value: 'CATERING',
  },
];

export const cookingMethodsOptions = [
  {
    label: 'Fried',
    value: 'FRIED',
  },
  {
    label: 'Grilled',
    value: 'GRILLED',
  },
];
